import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async getAll () {
    return axios.get('/api/applications/all')
      .then(r => r.data).catch(errorHandler)
  },
  async getState (state) {
    return axios.get(['/api/applications/', state].join(''))
      .then(r => r.data).catch(errorHandler)
  },
  async getApplicationsForJob ({ jobId, state }) {
    const x = state ? `/${state}` : ''
    return axios.get(['/api/applications/', jobId, x].join(''))
      .then(r => r.data).catch(errorHandler)
  },
  async getPending () {
    return this.getState('pending')
  },
  async getAccepted () {
    return this.getState('hired')
  },
  async getRejected () {
    return this.getState('rejected')
  },
  async update (id, data) {
    return axios.put(['/api/applications/', id].join(''), data)
      .then(r => r.data).catch(errorHandler)
  },
  async reject (id, data) {
    return axios.post(`/api/applications/${id}/reject`, data)
      .then(r => r.data).catch(errorHandler)
  },
  async getTally ({ jobId }) {
    return axios.get(`/api/applications/${jobId}/tally`)
      .then(r => r.data).catch(errorHandler)
  },
  async sendOffer (id, data) {
    return axios.post(`/api/applications/${id}/offer`, data)
      .then(r => r.data).catch(errorHandler)
  },
  async signupAndApply (data) {
    return axios.post('/api/applications/register-and-apply', data)
      .then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/applications.js